var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "review border m-auto s-layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "s-container"
  }, [_c('Header', {
    attrs: {
      "page-title": _vm.moduleConfig.page_title,
      "page-image": _vm.moduleConfig.page_image,
      "page-kv-image": _vm.moduleConfig.page_kv_image,
      "header-section": _vm.moduleConfig.header_section
    }
  }), _c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "currentTab": "apply"
    }
  }), _c('div', {
    staticClass: "content"
  }, [_c('coupon-filters', {
    staticClass: "s-mb-3",
    attrs: {
      "options": _vm.filterOptions
    },
    model: {
      value: _vm.filter,
      callback: function callback($$v) {
        _vm.filter = $$v;
      },
      expression: "filter"
    }
  }), _vm._l(_vm.coupons, function (item) {
    return _c('coupon-card', {
      key: item.id,
      attrs: {
        "coupon": item,
        "buttonText": "查看"
      }
    });
  })], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }